/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { SearchPaginateType } from "./datatable";

export interface IPaginationBaseState {
  pageSize?: number;
  sort?: string;
  order?: string;
  page?: number;
}

export interface Sortable {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export type GenericPageable = Pageable | SlicePageable;

export interface Pageable {
  sort?: Sortable;
  number: number;
  size: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
}

export interface SlicePageable {
  size: number;
  number: number;
  numberOfElements: number;
  hasNext: boolean;
  hasPrevious: boolean;
  totalPages?: number;
  totalElements?: number;
}

export interface SlicePaginationResponse<T> {
  content: T[];
  pageable: SlicePageable;
}

export interface PaginationResponse<T> {
  content: T[];
  pageable: Pageable;
}

export const initPageable: Pageable = {
  number: 0,
  size: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
};

export const initSlicePageable: SlicePageable = {
  size: 10,
  number: 0,
  numberOfElements: 0,
  hasNext: false,
  hasPrevious: false,
  totalPages: 0,
  totalElements: 0,
};

export const defaultPaginationBaseValue: Readonly<IPaginationBaseState> = {
  pageSize: 10,
  sort: "",
  order: "",
  page: 0,
};

export const initSearchPaginateState: Readonly<SearchPaginateType> = {
  page: 0,
  size: 10,
};

export const initGenericPageable: GenericPageable = {
  size: 10,
  number: 0,
  numberOfElements: 0,
  hasNext: false,
  hasPrevious: false,
  totalPages: 0,
  totalElements: 0,
};
